import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { ModalTransition } from '@atlaskit/modal-dialog';
import DeploymentDetailsDialog from '@atlassian/jira-software-deployment-frequency-report-deployment-details-dialog';
import { getWeekRangeFromWeekStartDate } from '../../common/utils/date-range';
import { NonCriticalErrorBoundary } from '../../common/utils/non-critical-error-boundary';
import { useSelectedWeekStore } from '../../controllers/selected-date-range';
import { useSelectedDeploymentId } from '../../controllers/selected-deployment';
import { usePeriodBreakdownMetrics } from '../../services/period-breakdown';
import { hasPermissionForAllIssues } from './utils';

export const DeploymentModal = () => {
	const [{ selectedWeekStart }] = useSelectedWeekStore();
	const selectedDateRange = selectedWeekStart
		? getWeekRangeFromWeekStartDate(selectedWeekStart)
		: null;
	const { loading, error, data } = usePeriodBreakdownMetrics(selectedDateRange);
	const [selectedDeploymentId, { setSelectedDeploymentId }] = useSelectedDeploymentId();
	if (loading || error || data == null) {
		return null;
	}
	const selectedDeployment = data.perDeploymentMetrics.find(
		(deployment) => deployment.id === selectedDeploymentId,
	);
	return (
		<NonCriticalErrorBoundary eventLocation="deploymentDetailsDialog" fallback="flag">
			<ModalTransition>
				{selectedDeployment && (
					<DeploymentDetailsDialog
						issueIds={selectedDeployment.issueIds}
						hasPermissionForAllIssues={hasPermissionForAllIssues(selectedDeployment)}
						deploymentDisplayName={selectedDeployment.displayName}
						deploymentUrl={selectedDeployment.url}
						onClose={() => {
							setSelectedDeploymentId(null);
						}}
					/>
				)}
			</ModalTransition>
		</NonCriticalErrorBoundary>
	);
};
